<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h13"><span class="th11">Dedication</span></h1>
<p class="p1">Special thanks to Nessa L. Warin for editing and mentorship, <span class="t2">and to the Dreamspinner team for all their tremendous work.</span></p>
<p class="p1"> </p>
<p class="p0">And as always, to my husband, who is my miracle </p>
<p class="p0">every single day.</p>
<p class="p1"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?09783aac